import Accordion from "accordion-js";
import "accordion-js/dist/accordion.min.css";

new Accordion("[data-accordion]");


const accordionElement = document.querySelector("[data-accordion]");
